{
  "title": "Add Multiple",
  "tooltip": "Add multiple items",
  "add": "Add",
  "save": "Add Items",
  "cancel": "Cancel",
  "remove": "Remove item",
  "batch_created_one": "{{count}} item created",
  "batch_created_other": "{{count}} items created",
  "batch_failed_one": "Something went wrong while creating new item — please try again",
  "batch_failed_other": "Something went wrong while creating new items — please try again"
}
